import React from 'react'

const AccessWrapper = ({ roles=[], children, component }) => {
    let officer = JSON.parse(sessionStorage.getItem("officer"));
    const userRole = officer?.roleMaster?.short_name;

    // If no roles passed, allow access by default
    const hasAccess =
        roles.length === 0 || roles.includes(userRole);

    if (hasAccess) {
        return <>{children}</>;
    }

    return <>{component}</>;
}

export default AccessWrapper;